import { render } from "./InitiativeList.vue?vue&type=template&id=6e735473&scoped=true"
import script from "./InitiativeList.vue?vue&type=script&lang=js"
export * from "./InitiativeList.vue?vue&type=script&lang=js"

import "./InitiativeList.vue?vue&type=style&index=0&id=6e735473&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e735473"]])

export default __exports__